import styled from 'styled-components/native';

export const ScreenBackground = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
`;
